export const getPersonnelFlightInfo = (previousPersonnelFlightsTask, persId, isFirstLeg) => {
    if (!isFirstLeg) {
        return null;
    }

    const flights = previousPersonnelFlightsTask.filter((flight) => flight.personnelID === persId);

    return flights.length > 0 ? flights[flights.length - 1].dateWorkEnd : null;
};
